// This file is automatically generated. Do not edit manually.

import { OAuthAuthenticationRequest } from "src/api/generated/common/oauth/oAuthAuthenticationRequest";
import { AavoObjectType } from "src/api/generated/common/aavoObject/aavoObjectType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ObjectDocumentSendingApi {
	export async function ensureAuthentication(): Promise<OAuthAuthenticationRequest | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tenantMail/objectDocumentSending/ensureAuthentication",
			method: "POST",
			data: {},
		});
		return response === "" ? null : (response as OAuthAuthenticationRequest | null);
	}

	export async function getFormInitData(args: {
		objectType: AavoObjectType;
		objectId: number;
	}): Promise<ObjectDocumentSendingApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tenantMail/objectDocumentSending/getFormInitData",
			method: "POST",
			data: {
				objectType: args.objectType,
				objectId: args.objectId,
			},
		});
		return response as ObjectDocumentSendingApi_FormInitData;
	}

	export async function sendDocuments(args: {
		objectId: number;
		objectType: AavoObjectType;
		mailSubject: string;
		mailContent: string;
		mailReceiver: string;
		saveMainDocument: boolean;
		mailFrom?: string | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/tenantMail/objectDocumentSending/sendDocuments",
			method: "POST",
			data: {
				objectId: args.objectId,
				objectType: args.objectType,
				mailSubject: args.mailSubject,
				mailContent: args.mailContent,
				mailReceiver: args.mailReceiver,
				saveMainDocument: args.saveMainDocument,
				mailFrom: args.mailFrom,
			},
		});
		return response as void;
	}
}

export interface ObjectDocumentSendingApi_FormInitData {
	defaultReceiver: string;
	defaultSubject: string;
	mainDocumentFriendlyName: string;
}
